import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

import { Typography } from '@zendesk/forethought-elements';
import { toConversationChannel } from '../utils';
import { DeepLink } from './DeepLink';
import type { FontVariant } from './fontVariant';
import {
  ErrorQueryEvent,
  MissingContextVariablePayload,
} from 'src/types/ErrorEventTypes';

export const MissingContextVariableFix = ({
  channel,
  fontVariant = 'font16',
  payload,
}: {
  channel: ErrorQueryEvent['channel'];
  fontVariant?: FontVariant;
  payload: MissingContextVariablePayload;
}) => {
  const { t } = useTranslation('events');
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
      }}
    >
      <Typography variant={fontVariant}>
        {t('missingContextVariableFix.intro')}
      </Typography>
      <Typography variant={fontVariant}>
        {t('missingContextVariableFix.method1')}
      </Typography>
      <Typography variant={fontVariant}>
        {t('missingContextVariableFix.method2')}
      </Typography>
      <Typography variant={fontVariant}>
        {t('missingContextVariableFix.method3')}
      </Typography>
      <Box
        sx={{
          mt: 1,
        }}
      >
        <DeepLink
          channel={toConversationChannel(channel)}
          stepId={payload.step_id}
          workflowId={payload.workflow_id}
        />
      </Box>
    </Box>
  );
};
